import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权
import {setSupport,getSupport,setCookie,getCookie} from '@/utils/support';

const whiteList = ['/login'] // 不重定向白名单
const defaultTitle = 'CRM'
router.beforeEach((to, from, next) => {
  // NProgress.start()
  if (getToken()) {
    // console.log('4566666',to.path)
    if (to.path === '/login') {
      // console.log(111)
      next({ path: '/' });
      // next();
      NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      document.title = to.meta.title ? to.meta.title : defaultTitle
      next();
      // next({ path: '/' })
      // if (store.getters.roles.length === 0) {
      //   store.dispatch('GetInfo').then(res => { // 拉取用户信息
      //     // console.log('res.data',res.data.data)
      //     // 权限setCookie

      //     setCookie("grouping",res.data.data.grouping);
      //     setCookie("is_main",res.data.data.is_main);
      //     setCookie("subuser_id",res.data.data.subuser_id);
      //     setCookie("company_name",res.data.data.company_name);

      //     let menus=res.data.data.menus;
		    //   // let menus=res.data.menus;
      //     // let username=res.data.username;
      //     let username=res.data.data.nickname;
      //     store.dispatch('GenerateRoutes', { menus,username }).then((ress) => { // 生成可访问的路由表
      //       router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
      //       next({ ...to, replace: true })
      //     })
      //   }).catch((err) => {
      //     store.dispatch('FedLogOut').then(() => {
      //       Message.error(err || 'Verification failed, please login again')
      //       next({ path: '/' })
      //     })
      //   })
      // } else {
      //   next()
      // }
    }
  } else {
    // console.log(99999)
    if (whiteList.indexOf(to.path) !== -1) {
      // console.log(888)
      next();
    } else {
      // console.log(777)
      next('/login');
      NProgress.done();
    }
  }
})

router.afterEach(() => {
  NProgress.done(); // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js